export const HTML_DATE_FORMAT_ABR = 'dd MMM yyyy';
export const HTML_DATE_FORMAT = 'yyyy-MM-dd';
export const HTML_TIME_FORMAT = 'HH:mm';
export const ISO_DATE_FORMAT = 'yyyy-MM-dd[T]HH:mm:ss[Z]';
export const MAX_DATE = new Date(9999, 11, 31);
export const MIN_DATE = new Date(-9999, 0, 1);
